import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = 'catalogos/funcion-presupuestal/';

/**
 * GET Funciones Presupuestales
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getFuncionesPresupuestales = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Función Presupuestal
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getFuncionPresupuestal = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Función Presupuestal
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postFuncionPresupuestal = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Función Presupuestal
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchFuncionPresupuestal = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Función Presupuestal
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteFuncionPresupuestal = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Función Presupuestal
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarFuncionPresupuestal = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
